import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.CostRateIncrease1,
  LocationVarKey.CostRateIncrease2,
  LocationVarKey.WantsBotInitiatedEscalationsRateIncreases
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Rate Increase
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.CostRateIncrease1} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.CostRateIncrease2}
        enableSwitchVar={LocationVarKey.CostRateIncrease2Enabled}
      />

      <SectionHeader
        {...page}
        subheading="If a bot has identified a rate increase concern, turning this on will escalate to a human team member."
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1")}
      >
        Bot-initiated Escalation
      </SectionHeader>
      <TextRow {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1")}></TextRow>
      <SwitchRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasLiveChat, "1")}
        keyName={LocationVarKey.WantsBotInitiatedEscalationsRateIncreases}
        label="Escalate to Human"
      />
    </>
  );
}
